import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { useParams } from "react-router-dom";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import "../css/map.css";
import { Notfound } from "./Notfound";

// Webpack mengganti nama file gambar Leaflet, jadi path ikon marker
// default harus diset manual supaya ikonnya tidak rusak.
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const LOCATIONS = {
  1: {
    position: [-6.1403114154852805, 106.88026441168148],
    name: "PT Bintang Wistar Kencana Jakarta",
    street:
      "JL. Agung Timur X Blok N-2/19, Jakarta, 14350, RT.10/RW.11,Sunter Jaya, Tanjung Priok, North Jakarta City, Jakarta 14350.",
  },
  2: {
    position: [-7.364285044795565, 112.68403171986309],
    name: "PT Bintang Wistar Kencana Surabaya",
    street:
      "Kompleks Pergudangan Tritan Blok C 36-37, Jemundo, Taman, Jemundo, Sidoarjo, Kabupaten Sidoarjo, Jawa Timur 61257",
  },
  3: {
    position: [-8.638682215988418, 115.20382377555829],
    name: "PT Bintang Wistar Kencana Bali",
    street:
      "Jl. Bung Tomo No.311A, Pemecutan Kaja, Kec. Denpasar Utara, Kota Denpasar, Bali 80111",
  },
};

const ServiceArea = () => {
  const { id } = useParams();
  const location = LOCATIONS[id];

  if (!location) {
    return <Notfound />;
  }

  return (
    <div>
      {/* key={id}: MapContainer tidak mengikuti perubahan prop center,
          jadi peta di-mount ulang saat pindah lokasi. */}
      <MapContainer
        key={id}
        center={location.position}
        zoom={13}
        scrollWheelZoom={true}
        id="mapid"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={location.position}>
          <Popup>
            <b>{location.name}</b> <br />
            {location.street}
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default ServiceArea;
